import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const TextContainer = styled.div`
    a {
        border-bottom: 2px solid rgba(35, 161, 75, var(--tw-bg-opacity));
    }
    img {
        margin: 1rem auto;
        text-align: center;
    }
    p {
        margin-bottom: 0.65rem;
    
        > code {
            font-family: inherit;
            background-color:rgba(201, 8, 8, 0.35);
            word-wrap: break-word;
            box-decoration-break: clone;
            padding: .1rem .3rem .2rem;
            border-radius: .2rem;
            margin-bottom: 1rem;
        }
    }
    ul {
        list-style-type: disc;

        li {
            margin-left: 2rem;
            margin-bottom: .5rem;
        }
    }
`;

const S = {
  TextContainer,
};

export default S;
